<template>
  <app-view class="container">
    <div class="tab fixedTop">
      <a href="javascript:;" :class="{on:type===0}" @click="type=0">最近更新</a>
      <a href="javascript:;" :class="{on:type===1}" @click="type=1">最新发布</a>
    </div>
    <div class="content">
      <movie-cover v-for="(item,index) in list" :key="index" :value="item" :more="more"></movie-cover>
    </div>
  </app-view>
</template>
<script>
  import AppView from '../components/AppView.vue'
  import MovieCover from '../components/MovieCover.vue'

  export default {
    components: {AppView, MovieCover},
    data () {
      return {
        type: 0,
        newList: [],
        updateList: []
      }
    },
    computed: {
      list () {
        return this.type === 0 ? this.updateList : this.newList
      },
      more () {
        return this.type === 0 ? 'update' : 'add'
      }
    },
    async mounted () {
      let {new_list, update_list} = await this.$service.movie.loadLatest()
      this.newList = new_list
      this.updateList = update_list
    }
  }
</script>
<style scoped lang='scss'>
  .container {
    padding-top: 50px;
    .tab {
      display: flex;
      border-bottom: thin solid $color-red;
      background-color: $color-white;
      a {
        height: 50px;
        line-height: 54px;
        font-size: 16px;
        flex: 1;
        text-align: center;
        &.on {
          color: $color-red;
          border-bottom: 3px solid $color-red;
        }
      }
    }
    .content {
      display: flex;
      flex-wrap: wrap;
      align-content: flex-start;
      padding: rem(6);
      > a {
        margin: rem(6);
      }
    }
    @media screen and (min-width: 768px) {
      .content {
        padding: rem(3);
        > a {
          margin: rem(3.5);
        }
      }
    }

    @media screen and (min-width: 1024px) {
      .content {
        padding: rem(3);
        > a {
          margin: rem(2.5);
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// latest.vue?50a5a888